// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7110":"b6f59c16ba0ff6e9","9217":"7610bff332639ad1"}[chunkId] + ".css";
};